/* eslint-disable @typescript-eslint/no-empty-interface */
const config = { domain: 'Account', subdomain: 'Settings' }

interface EditClicked {}
interface Clicked {}
interface ZeroPartyDataSaveClicked {
  fieldsUpdated: string[]
}

interface ZeroPartyDataSaved {
  fieldsUpdated: string[]
}

interface RetryClicked {
  fieldsUpdated: string[]
}

interface PrivacyPolicyClicked {}

interface TermsClicked {}

interface HelperMessageClicked {
  modalOpened: string
}

export const settings = {
  Clicked: {
    Clicked: (param: Clicked) => param,
    config,
  },
  Edit_Clicked: {
    Edit_Clicked: (param: EditClicked) => param,
    config,
  },
  Zero_Party_Data_Save_Clicked: {
    Zero_Party_Data_Save_Clicked: (param: ZeroPartyDataSaveClicked) => param,
    config,
  },
  Zero_Party_Data_Saved: {
    Zero_Party_Data_Saved: (param: ZeroPartyDataSaved) => param,
    config,
  },
  Retry_Clicked: {
    Retry_Clicked: (param: RetryClicked) => param,
    config,
  },
  Privacy_Policy_Clicked: {
    Privacy_Policy_Clicked: (param: PrivacyPolicyClicked) => param,
    config,
  },
  Terms_Clicked: {
    Terms_Clicked: (param: TermsClicked) => param,
    config,
  },
  Helper_Message_Clicked: {
    Helper_Message_Clicked: (param: HelperMessageClicked) => param,
    config,
  },
}
